/** @jsxImportSource theme-ui */

import { BaseIcon } from './base-icon'

export const SwapIcon: BaseIcon = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
      <path d="M240.3 177.4c9.75-8.977 10.34-24.18 1.344-33.94L145.6 39.37c-9.062-9.82-26.19-9.82-35.25 0L14.38 143.4c-9 9.758-8.406 24.96 1.344 33.94C20.35 181.7 26.19 183.8 32 183.8c6.469 0 12.91-2.594 17.62-7.719L104 117.1v338.9C104 469.2 114.8 480 128 480s24-10.76 24-24.02V117.1l54.37 58.95C215.3 185.8 230.5 186.5 240.3 177.4zM432.3 334.6c-9.779-9.07-24.97-8.414-33.9 1.344L344 394.9V56.02C344 42.76 333.3 32 320 32s-24 10.76-24 24.02v338.9l-54.37-58.95c-4.719-5.125-11.16-7.719-17.62-7.719c-5.812 0-11.66 2.094-16.28 6.375c-9.75 8.977-10.34 24.18-1.344 33.94l95.1 104.1c9.062 9.82 26.19 9.82 35.25 0l95.1-104.1C442.6 358.8 442 343.6 432.3 334.6z" />
    </svg>
  )
}
